/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      // console.log('Container ———————— ↓');
      // console.log(container);
      // console.log('Variant —————————— ↓');
      // console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      // console.log('Cart ———————————— ↓');
      // console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    // console.log('theme:cart:init');
    // console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { 
    // console.log(e);
  });
  document.addEventListener('theme:scroll:up', e => { 
    // console.log(e);
  });
  document.addEventListener('theme:scroll:down', e => {
    // console.log(e);
  });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { 
    // console.log(e); 
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

$(function() {
  // sample
  let needToHidaATC = true;
  if ($('body').hasClass('cb-standard_add_to_cart_flow_class') || $('body').hasClass('cb-template-fabric-piece')) {
    needToHidaATC = false;
  }
   if(needToHidaATC && $('body').hasClass('template-product')){
    $('button[type="submit"][data-add-to-cart]').hide();
   }
   $('.sample-switcher input').on('click', function() {
     const samples_count = parseInt($(this).data('samples-count'));
     const sample_in_cart = $('.sample-switcher input').attr('data-sample-in-cart');
     
     const parentContainer = $(this).parents('.switcher-container').siblings('.sample-description');
     if ($(this).is(':checked')) {
  
       if (sample_in_cart === 'true' || samples_count >= 4) {
         $('button[type="submit"][data-add-to-cart]')[0].disabled = true;
       }

       $('button[type="submit"][data-add-to-cart]').show();
       parentContainer.slideDown('fast');
       parentContainer.siblings('.product__block__quantity').hide();
       parentContainer.parents('.product__inner').find('.btn-state-ready span[data-button-price]').hide()
       parentContainer.parents('.product__inner').find('.btn-state-ready .cta__dot').hide()
     } else {
       $('button[type="submit"][data-add-to-cart]').hide();
       $('button[type="submit"][data-add-to-cart]')[0].disabled = false;
       parentContainer.slideUp('fast');
       parentContainer.siblings('.product__block__quantity').show();
       parentContainer.parents('.product__inner').find('.btn-state-ready span[data-button-price]').show()
       parentContainer.parents('.product__inner').find('.btn-state-ready .cta__dot').show()
     }
   });

  // checkout
  $('.template__cart__footer').find('.checkout__button').attr('disabled','disabled');
  $('#cart-form').find('.checkout__button').attr('disabled','disabled');

  $('.company-container input').on('click', function() {
    
    const parentContainer = $(this).parents('.company-container').siblings('.company-form');

    if ($(this).attr('id') == 'company' && $(this).is(':checked')) {
      parentContainer.slideDown('fast');
      parentContainer.parents('.template__cart__footer').find('.checkout__button').removeAttr('disabled');
      parentContainer.parents('.cart__drawer').find('.checkout__button').removeAttr('disabled');
      
      $('#vat-number').attr('required', true);

      $('#cb-checkout').off('click');
      $('#cb-checkout').on('click', function(e) {
        e.preventDefault();
        $('#vat-number').removeClass('error');
        $('.cb-vat-error').removeClass('cb-error');
        let code = $('#vat-number').val();

        if (code === '') {
          $('#vat-number').addClass('error');
          $('.cb-vat-error').addClass('cb-error');
        } else {
          let cartjson = $(this).data('cartjson');
          let sdi_code = $('#sdi-code').val();
          let email_pec = $('#email-pec').val();
          cartjson.sdi_code = sdi_code;
          cartjson.email_pec = email_pec;
          let cartjsonstr = JSON.stringify(cartjson);
          console.log(cartjson);

          // $.getJSON('https://alt.cartblender.com/projects/evaresource/vat_validate.php?code=' + code + '&cartjson=' + cartjsonstr, function(res) {

          //   if (res !== null && res.isValid === true) {
          //     if (res.invoice_url !== undefined && res.invoice_url !== null) {
          //       window.location.href = res.invoice_url;
          //     } else {
          //       $('.template__cart__footer button.checkout__button').click();
          //     }
          //   } else {
          //     $('#vat-number').addClass('error');
          //     $('.cb-vat-error').addClass('cb-error');
          //   }
          // });

          $.post('https://alt.cartblender.com/projects/evaresource/vat_validate.php', {code: code, cartjson: cartjsonstr})
          .done(function(res) {
            res = JSON.parse(res);
            if (res !== null && res.isValid === true) {
              if (res.invoice_url !== undefined && res.invoice_url !== null) {
                window.location.href = res.invoice_url;
              } else {
                $('.template__cart__footer button.checkout__button').click();
                $('#cart-form button.checkout__button').click();
              }
            } else {
              $('#vat-number').addClass('error');
              $('.cb-vat-error').addClass('cb-error');
            }
          });
          
        }
      });
      
    } else {
      parentContainer.slideUp('fast');
      $('#vat-number').removeAttr('required');
      parentContainer.parents('.template__cart__footer').find('.checkout__button').removeAttr('disabled');
      parentContainer.parents('.cart__drawer').find('.checkout__button').removeAttr('disabled');

      $('#cb-checkout').off('click');
      $('#cb-checkout').on('click', function(e) {
        e.preventDefault();
        $('.template__cart__footer button.checkout__button').click();
        $('#cart-form button.checkout__button').click();
      });
      
    }

 });

  $('.company-form input#vat-number').on('input', function () {
    if ($(this).val().toLowerCase().includes('it')) {
      $('.company-form input#sdi-code').show();
      $('.company-form input#email-pec').show();
    } else {
      $('.company-form input#sdi-code').hide();
      $('.company-form input#email-pec').hide();
    }
  });


  // geolocation
  $.get("https://ipinfo.io", function(response) {

    if (response !== undefined && response !== false && typeof response.country === 'string') {

      // CART PAGE VAT
      if ($('.company-form input#vat-number').length > 0) {
        $('.company-form input#vat-number').val(response.country);
      }

      if (response.country !== 'IT') {
        $('.company-form input#sdi-code').hide();
        $('.company-form input#email-pec').hide();
      }

      // PRESELECT
      $('[type="radio"][name="private-company"]#private').click();

      // PRICES
      let rates = JSON.parse($('#json-taxes').text());
      let taxableCountries = [];
      let currentRate = 0;
      let taxesIncluded = $('#cb-taxes_included').data('val');
      let accountType = $('#cb-account_type').data('val');
      let currentCountryDown = response.country.toLowerCase();
      for (let index = 0; index < rates.length; index++) {
        if (currentCountryDown === rates[index].country.toLowerCase()) {
          currentRate = parseInt(rates[index].tax);
        }
        taxableCountries.push(rates[index].country.toLowerCase());
      }

      let cbIncludeTax = false;
      let preselectRole = false;

      if (taxableCountries.includes(currentCountryDown)) {
        // EU
        if (accountType === 'company') {
          cbIncludeTax = false;
          if (currentCountryDown === 'it') {
            cbIncludeTax = true;
          }
          preselectRole = 'company';
        } else if (accountType === 'customer') {
          cbIncludeTax = true;
          preselectRole = 'private';
        } else if (accountType === 'guest') {
          cbIncludeTax = true;
        }
      } else {
        // NON EU
        cbIncludeTax = false;
        preselectRole = 'international';
      }

      let needToAddTax = false;
      let needToRemoveTax = false;      

      if ((taxesIncluded === true && cbIncludeTax === true) || (taxesIncluded === false && cbIncludeTax === false)) {
        // do nothing
      } else if (taxesIncluded === true && cbIncludeTax === false) {
        needToRemoveTax = true;
      } else if (taxesIncluded === false && cbIncludeTax === true) {
        needToAddTax = true;
      }
      
      // if (needToAddTax === false && needToRemoveTax === true) {
      //   cbFormatMoneyRemoveTax();
      //   setInterval(cbFormatMoneyRemoveTax, 1000);
      //   $('.vat-excluded').show();
      //   $('.cb-shipping_at_checkout').show();
      //   $('.cb-shipping_without_taxes_at_checkout').hide();
      // } else if (needToAddTax === true && needToRemoveTax === false) {
      //   cbFormatMoneyAddTax();
      //   $('.cb-shipping_at_checkout').hide();
      //   $('.cb-shipping_without_taxes_at_checkout').show();
      //   setInterval(cbFormatMoneyAddTax, 1000);
      // }

      if (preselectRole !== false) {
        $('[type="radio"][name="private-company"]#' + preselectRole).click();
      }
      

      function cbFormatMoneyAddTax() {
        $('.cb-money').each(function () {
          if ($(this).hasClass('cb-formatted') === false) {
            let priceVal = $(this).text();
            priceVal = priceVal.replace('€', '').replace('.', '').replace(',', '.').replace('EUR', '').replace(' ', '');
            let priceValFloat = parseFloat(priceVal);
            let newPriceValFloat = priceValFloat * ((100 + currentRate) / 100);
            if($(this).is('.cb-cart-total')){
              let giftCardsSum = 0;
              $('.cart__items__price .cb-gift-card-money').each(function(){
                let giftCardFloat = parseFloat($(this).text().replace('€', '').replace('.', '').replace(',', '.').replace('EUR', '').replace(' ', ''));
                let quantity = $(this).closest('.cart__items__row').find('.quantity__input').val();
                giftCardsSum += (giftCardFloat * quantity)
              });
              newPriceValFloat = (priceValFloat - giftCardsSum)  * ((100 + currentRate) / 100) + giftCardsSum;
            } 
            if($(this).is('.cb-gift-card-money')) newPriceValFloat = priceValFloat;
            let newPriceVal = themeVendor.themeCurrency.formatMoney(newPriceValFloat*100, theme.moneyFormat);
            if ($(this).hasClass('money_with_currency')) {
              newPriceVal = themeVendor.themeCurrency.formatMoney(newPriceValFloat*100, theme.moneyFormat) + ` ${theme.currencyCode}`;
            }
            $(this).text(newPriceVal);
            $(this).addClass('cb-formatted');
          }
        });
      }
      function cbFormatMoneyRemoveTax() {
        $('.cb-money').each(function () {
          if ($(this).hasClass('cb-formatted') === false) {
            let priceVal = $(this).text();
            priceVal = priceVal.replace('€', '').replace('.', '').replace(',', '.').replace('EUR', '').replace(' ', '');
            let priceValFloat = parseFloat(priceVal);
    
            let newPriceValFloat = priceValFloat * 100 / (100 + currentRate);
            let newPriceVal = themeVendor.themeCurrency.formatMoney(newPriceValFloat*100, theme.moneyFormat);
            if ($(this).hasClass('money_with_currency')) {
              newPriceVal = themeVendor.themeCurrency.formatMoney(newPriceValFloat*100, theme.moneyFormat) + ` ${theme.currencyCode}`;
            }
            $(this).text(newPriceVal);
            $(this).addClass('cb-formatted');
          }
        });
      }
    }
  }, "jsonp");




  
});